// extracted by mini-css-extract-plugin
export var container = "styles-module__container___ul_ja";
export var fadeIn = "styles-module__fadeIn____zx91";
export var contentContainer = "styles-module__contentContainer___BMnt7";
export var heading = "styles-module__heading____ZMFh";